import React, { useState, useEffect } from 'react';
import { login } from '../api_controll/apiClient';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { setUser } from '../redux/userSlice';

function LoginPage() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user = useSelector(state => state.user.user);

  // Když už je user v Reduxu (bootstrapAuth), pošleme ho rovnou na /stations
  useEffect(() => {
    if (user?.username) {
      navigate('/stations');
    }
  }, [user, navigate]);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError(null);

    if (!username || !password) {
      setError('Prosím vyplňte přihlašovací údaje');
      return;
    }

    try {
      const credentials = { username, password };
      const data = await login(credentials); // nový login z apiClientu

      // login() už uložil access token, my si vezmeme usera
      // backend vrací: user: { id, username, role }
      const userForRedux = {
        id: data.user.id,
        username: data.user.username,
        role_name: data.user.role, // sjednotíme shape pro zbytek appky
      };

      dispatch(setUser(userForRedux));
      navigate('/stations');
    } catch (err) {
      console.error('Login failed:', err);
      setError('Neplatné přihlašovací údaje');
    }
  };

  return (
    <div className="container">
      <h2>Přihlášení</h2>
      <form onSubmit={handleLogin}>
        <input
          type="text"
          placeholder="Uživatelské jméno"
          value={username}
          className="sign-input"
          onChange={(e) => setUsername(e.target.value)}
        />

        <input
          type="password"
          placeholder="Heslo"
          className="sign-input"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />

        <button className="sign-button" type="submit">
          Přihlásit
        </button>
      </form>
      {error && <div className="error-text">{error}</div>}
    </div>
  );
}

export default LoginPage;
